//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// suggestion-body-config-colors imports
import { IContainer, IProps, ICircle } from "./SuggestionBodyConfigColors.d";
import { suggestionBodyConfigColorsFragments } from "./SuggestionBodyConfigColors.gql";
import * as s from "./SuggestionBodyConfigColors.styles";
// other components
import { A } from "@ui";
// state
import { IReduxState } from "@reducers/root.reducer";
import { setSettingsDialogOpen } from "@actions/chrome-extension.actions";
import { toggleExpanded } from "@actions/settings.actions";
// util
import { getMergedDefaultSet } from "@util/event-category-coloring.util";
// material-ui
import { IconButton, Tooltip } from "@material-ui/core";
import { Brightness1 } from "@material-ui/icons";

//////////////////
// COMPONENTs
//////////////////
// helper component for displaying a color
const ColorCircle = ({ tip, color }: ICircle) => {
  return (
    <Tooltip key={color} title={tip} placement="top-start">
      <IconButton style={s.smallBtn}>
        <Brightness1 style={{ ...s.smallIcon, color }} />
      </IconButton>
    </Tooltip>
  );
};

// primary component
class SuggestionBodyConfigColorsCmpt extends React.Component<IProps> {
  private onClickSettings = () => {
    this.props.setSettingsDialogOpen(true);
    this.props.toggleExpanded("expandColorCoding");
  };

  public render() {
    const displaySet = getMergedDefaultSet(this.props.org.eventColoringSettingsErrorable);
    return (
      <div style={s.container}>
        {displaySet.map((set, i) => {
          return <ColorCircle key={i} color={set.color} tip={set.label} />;
        })}
        <A style={s.moreSettingsLink} onClick={this.onClickSettings}>
          More in Settings
        </A>
      </div>
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

export const SuggestionBodyConfigColors_redux = connect(mapStateToProps, {
  setSettingsDialogOpen,
  toggleExpanded,
})(SuggestionBodyConfigColorsCmpt);

export const SuggestionBodyConfigColors = createFragmentContainer<IContainer>(
  SuggestionBodyConfigColors_redux,
  suggestionBodyConfigColorsFragments,
);
